import { Language } from '@ha/intl';
import { FeaturedCountries } from 'ha/constants/FeaturedCountries';
import {
  getMarketingPageUrl,
  getMarketingPage,
} from 'ha/modules/Hermes/utils/getMarketingPage';
import { formatHrefURL } from 'ha/utils/formatHrefURL';
import { ContentfulSupportedLangs } from '../constants';

const isEqualPath = (pathname: string, slug: string, lang: Language) => {
  if (lang === Language.en) {
    return true;
  }

  return `/${lang}/${slug}` === pathname;
};

export const marketingPagePath = (
  pathname: string,
  lang: Language,
  sourceLang: Language,
) => {
  const { decodedPathname, slug, marketingPageIndex, isMarketingPage } =
    getMarketingPage(pathname, lang);

  if (isMarketingPage && isEqualPath(decodedPathname, slug, lang)) {
    const path = getMarketingPageUrl(marketingPageIndex, sourceLang);
    return {
      hasValidPath: true,
      path: formatHrefURL(path, sourceLang),
    };
  }

  return {
    hasValidPath: false,
    path: pathname,
  };
};

const featuredCountryPath = (pathname: string, lang: Language): string => {
  if (ContentfulSupportedLangs.includes(lang)) {
    return pathname;
  }
  const featuredCountry = FeaturedCountries.find(country =>
    isEqualPath(pathname, country.name, lang),
  );
  if (featuredCountry) {
    return `/${featuredCountry.name}`;
  }
  return pathname;
};

const getPath = (pathname: string, lang: Language) => {
  const sourceLang = ContentfulSupportedLangs.includes(lang)
    ? lang
    : Language.en;
  const { path, hasValidPath } = marketingPagePath(pathname, lang, sourceLang);

  if (hasValidPath) {
    return path;
  }

  return featuredCountryPath(pathname, lang);
};

export { getPath };
